import axios from "axios";
import URLParamService from "./URLParamService";

const queryParams = URLParamService.getQueryParams();
const promoId = queryParams.promoId;
const organizationId = queryParams.organizationId;
const sessionId = queryParams.session;
const lng = queryParams.lng;
const gameBaseUrl = queryParams.gameUrl;
const imageBaseUrl = queryParams.imageUrl;
const gameId = queryParams.gameId;
const providerId = queryParams.providerId;
const showGameImages = queryParams.showGameImages;
const enableGameNavigation = queryParams.enableGameNavigation;
const showInactiveBetPopup = queryParams.showInactiveBetPopup;
const supportPhone = queryParams.supportPhone;
const origin = queryParams.origin;
const cdnBaseURL = import.meta.env.VITE_WIDGET_CDN_BASE_URL;

const isPromoValid = (): boolean => {
  if (queryParams.hasOwnProperty("promoId") && promoId) {
    return true;
  }
  return false;
};

const getPromoId = (): string => {
  if (queryParams.hasOwnProperty("promoId") && promoId?.length > 0) {
    return promoId;
  }
  return "";
};
const getOrganizationId = (): string => {
  if (queryParams.hasOwnProperty("organizationId") && organizationId?.length > 0) {
    return organizationId;
  }
  return "";
};

const getSession = (): string => {
  if (queryParams.hasOwnProperty("session") && sessionId?.length > 0) {
    return sessionId;
  }
  return "undefined";
};

const getLng = (): string => {
  if (queryParams.hasOwnProperty("lng") && lng?.length > 0) {
    return lng;
  }
  return "";
};

const getGameBaseUrl = (): string => {
  if (queryParams.hasOwnProperty("gameUrl") && gameBaseUrl?.length > 0) {
    return gameBaseUrl;
  }
  return "";
};

const getImageBaseUrl = (): string => {
  if (queryParams.hasOwnProperty("imageUrl") && imageBaseUrl?.length > 0) {
    return imageBaseUrl;
  }
  return "";
};

const getShowGameImages = (): boolean => {
  if (queryParams.hasOwnProperty("showGameImages")) {
    return showGameImages === "true" || showGameImages === "1";
  }
  return true;
};

const getEnableGameNavigation = (): boolean => {
  if (queryParams.hasOwnProperty("enableGameNavigation")) {
    return enableGameNavigation === "true" || enableGameNavigation === "1";
  }
  return true;
};

const getShowErrorBlockPopup = (): boolean => {
  if (queryParams.hasOwnProperty("showInactiveBetPopup")) {
    return showInactiveBetPopup === "true" || showInactiveBetPopup === "1";
  }
  return false;
};

const getSupportPhone = (): string => {
  if (queryParams.hasOwnProperty("supportPhone") && supportPhone?.length > 0) {
    return supportPhone;
  }
  return "";
};

const getOrigin = (): string => {
  if (queryParams.hasOwnProperty("origin") && origin?.length > 0) {
    return origin;
  }
  return "";
};

const getGameId = (): string => {
  if (queryParams.hasOwnProperty("gameId") && gameId?.length > 0) {
    return gameId;
  }
  return "";
};

const getProviderId = (): string => {
  if (queryParams.hasOwnProperty("providerId") && providerId?.length > 0) {
    return providerId;
  }
  return "";
};

const ConfigService = {
  cdnBaseURL,
  isPromoValid,
  getPromoId,
  getGameId,
  getProviderId,
  getSession,
  getLng,
  getGameBaseUrl,
  getImageBaseUrl,
  getShowGameImages,
  getEnableGameNavigation,
  getShowErrorBlockPopup,
  getSupportPhone,
  getOrigin,
};

export default ConfigService;
